/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_TitleInputs */

const en_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Preview`)
};

const fr_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation des sous-titres`)
};

const de_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Vorschau`)
};

const it_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dei sottotitoli`)
};

const ru_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр субтитров`)
};

const es_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de subtítulos`)
};

const zh_cn2_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕预览`)
};

const ja_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕プレビュー`)
};

const hi_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक पूर्वावलोकन`)
};

const pt_pt2_video_export_preview_title = /** @type {(inputs: Video_Export_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle Preview" |
*
* @param {Video_Export_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_title = /** @type {((inputs?: Video_Export_Preview_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_title(inputs)
	if (locale === "de") return de_video_export_preview_title(inputs)
	if (locale === "it") return it_video_export_preview_title(inputs)
	if (locale === "ru") return ru_video_export_preview_title(inputs)
	if (locale === "es") return es_video_export_preview_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_title(inputs)
	if (locale === "ja") return ja_video_export_preview_title(inputs)
	if (locale === "hi") return hi_video_export_preview_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_title(inputs)
	return en_video_export_preview_title(inputs)
});